import NotLoggedMiddleware from "../../routes/middleware/NotLoggedMiddleware";
import LoggedMiddleware from "../../routes/middleware/LoggedMiddleware";
import ContextRequiredMiddleware from "../../routes/middleware/ContextRequiredMiddleware";
import ContextMiddleware from "@/routes/middleware/ContextMiddleware";

const ResetPassword = () => import("./views/ResetPassword");
const UserImpersonate = () => import('./views/UserImpersonate');
const UserImpersonateBack = () => import('./views/UserImpersonateBack');
const Oauth2View = () => import('./views/Oauth2View.vue');
const ExternalOAuth2Code = () => import('./views/ExternalOauth2CodeView');
export default [
    {
        path: '/authentication/reset-password',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            middleware: [NotLoggedMiddleware]
        }
    },

    {
        path: '/authentication/impersonate-user/:uuid',
        name: 'UserImpersonate',
        component: UserImpersonate,
        meta: {
            middleware: [ContextRequiredMiddleware, LoggedMiddleware]
        }
    },

    {
        path: '/authentication/deimpersonate-user',
        name: 'UserImpersonateBack',
        component: UserImpersonateBack,
        meta: {
            middleware: [ContextRequiredMiddleware, LoggedMiddleware]
        }
    },

    {
        path: '/auth/oauth2',
        name: 'OAuth2Login',
        component: Oauth2View
    },

    {
        path: '/external-oauth/check-code',
        name: 'ExternalOAuth2Code',
        component: ExternalOAuth2Code,
        meta: {
            middleware: ContextMiddleware
        }
    }
]
